import React from 'react';

const ExpertMarketLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    data-testid="expertMarketLogo"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <g id="Artboard1" transform="matrix(0.8,0,0,1,0,0)">
      <rect x="0" y="0" width="250" height="50" style={{ fill: 'none' }} />
      <g transform="matrix(0.479121,0,0,0.383296,28.7925,12.9005)">
        <g>
          <path
            d="M59.58,49.387L67.73,49.387L67.73,41.227L59.5,32.987L51.34,41.147L59.58,49.387Z"
            style={{
              fill: 'rgb(99,197,180)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
      <g transform="matrix(0.479121,0,0,0.383296,28.7925,12.9005)">
        <g>
          <path
            d="M43.1,16.587L34.95,16.587L34.95,24.757L43.22,32.987L51.34,24.837L43.1,16.587Z"
            style={{
              fill: 'rgb(81,181,230)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
      <g transform="matrix(0.479121,0,0,0.383296,28.7925,12.9005)">
        <g>
          <path
            d="M34.95,41.267L34.95,49.367L43.11,49.367L51.35,41.147L43.23,32.987L34.95,41.267Z"
            style={{
              fill: 'rgb(249,159,34)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
      <g transform="matrix(0.479121,0,0,0.383296,28.7925,12.9005)">
        <g>
          <path
            d="M67.73,16.587L59.58,16.587L51.34,24.837L59.5,32.987L67.73,24.787L67.73,16.587Z"
            style={{
              fill: 'rgb(243,113,95)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
      <g transform="matrix(0.479121,0,0,0.383296,28.7925,12.9005)">
        <g>
          <path
            d="M43.22,32.987L51.34,41.147L59.5,32.987L51.34,24.837L43.22,32.987Z"
            style={{
              fill: 'rgb(32,176,153)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
      <g transform="matrix(0.479121,0,0,0.383296,28.7925,12.9005)">
        <g>
          <path
            d="M181.28,6.727L173.28,6.727L173.28,11.327C173.28,14.277 171.68,16.567 168.21,16.567L166.54,16.567L166.54,24.467L172.49,24.467L172.49,39.737C172.49,46.067 176.49,49.877 182.89,49.877C185.49,49.877 187.09,49.407 187.89,49.077L187.89,41.707C187.43,41.827 186.21,41.977 185.14,41.977C182.59,41.977 181.24,41.027 181.24,38.177L181.24,24.407L187.92,24.407L187.92,16.507L181.34,16.507L181.34,6.707L181.3,6.707L181.28,6.727ZM164.13,16.407C163.43,16.337 162.8,16.307 162.07,16.307C159.25,16.307 154.72,17.107 152.73,21.447L152.73,16.527L144.13,16.527L144.13,49.347L153,49.347L153,34.327C153,27.227 156.93,25.067 161.46,25.067C162.26,25.067 163.14,25.137 164.13,25.327L164.13,16.407ZM133.13,37.757C132.08,40.687 129.79,42.757 125.67,42.757C121.25,42.757 117.59,39.627 117.4,35.277L140.88,35.277C140.88,35.157 140.98,33.777 140.98,32.527C140.98,22.007 134.93,15.527 124.78,15.527C116.38,15.527 108.63,22.347 108.63,32.787C108.63,43.887 116.56,50.337 125.6,50.337C133.68,50.337 138.86,45.607 140.54,39.937L133.14,37.757L133.13,37.757ZM117.59,29.217C117.77,26.217 120.32,22.737 124.94,22.737C130.01,22.737 132.14,25.937 132.29,29.217L117.59,29.217ZM97.34,32.957C97.34,38.827 93.72,42.217 89.18,42.217C84.64,42.217 80.98,38.747 80.98,32.957C80.98,27.157 84.64,23.727 89.18,23.727C93.75,23.727 97.33,27.157 97.33,32.957M81.13,62.077L81.13,46.187C82.73,48.387 86.09,50.187 90.63,50.187C99.88,50.187 106.1,42.827 106.1,32.917C106.1,23.157 100.57,15.837 90.96,15.837C86.01,15.837 82.36,18.037 80.9,20.567L80.9,16.527L72.3,16.527L72.3,62.027L81.13,62.027L81.13,62.077ZM30.46,49.387L30.46,40.687L10.02,40.687L10.02,29.757L28.52,29.757L28.52,21.557L10,21.557L10,10.737L30.44,10.737L30.44,2.037L0.8,2.037L0.8,49.387L30.46,49.387ZM256.72,49.387L256.72,2.027L244.18,2.027L230.3,36.227L216.08,2.027L203.93,2.027L203.93,49.387L212.73,49.387L212.73,16.487L226.38,49.387L234.04,49.387L247.64,16.217L247.64,49.387L256.72,49.387Z"
            style={{
              fill: 'rgb(94,94,97)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
      <g transform="matrix(0.479121,0,0,0.383296,28.7925,12.9005)">
        <g>
          <path
            d="M273.45,43.707C270.59,43.707 269.18,41.837 269.18,39.887C269.18,37.337 270.98,36.087 273.26,35.737L280.66,34.587L280.66,36.087C280.66,41.907 277.19,43.707 273.46,43.707M260.3,40.427C260.3,45.567 264.57,50.297 271.58,50.297C276.46,50.297 279.58,48.017 281.26,45.427C281.26,46.687 281.42,48.527 281.61,49.357L289.77,49.357C289.57,48.207 289.35,45.887 289.35,44.127L289.35,28.037C289.35,21.437 285.47,15.577 275.05,15.577C266.25,15.557 261.53,21.237 261,26.377L268.88,28.077C269.14,25.207 271.28,22.727 275.18,22.727C278.9,22.727 280.68,24.667 280.68,26.997C280.68,28.137 280.08,29.057 278.22,29.317L270.12,30.537C264.65,31.267 260.3,34.537 260.3,40.417M313.36,16.407C312.66,16.337 312.03,16.307 311.3,16.307C308.48,16.307 303.94,17.107 301.96,21.447L301.96,16.527L293.36,16.527L293.36,49.347L302.23,49.347L302.23,34.327C302.23,27.227 306.16,25.067 310.69,25.067C311.49,25.067 312.36,25.137 313.35,25.327L313.35,16.407L313.36,16.407Z"
            style={{
              fill: 'rgb(94,94,97)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
      <g transform="matrix(0.479121,0,0,0.383296,28.7925,12.9005)">
        <g>
          <path
            d="M348.4,16.527L336.76,16.527L325.44,28.757L325.44,1.057L316.56,1.057L316.56,49.377L325.44,49.377L325.44,40.677L329.1,36.827L337.75,49.367L348.65,49.367L335.25,30.337L348.4,16.527Z"
            style={{
              fill: 'rgb(94,94,97)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
      <g transform="matrix(0.479121,0,0,0.383296,28.7925,12.9005)">
        <g>
          <path
            d="M394.2,6.727L386.2,6.727L386.2,11.327C386.2,14.277 384.6,16.567 381.13,16.567L379.46,16.567L379.46,24.467L385.4,24.467L385.4,39.737C385.4,46.067 389.4,49.877 395.8,49.877C398.4,49.877 400,49.407 400.8,49.077L400.8,41.707C400.34,41.867 399.12,41.977 398.05,41.977C395.5,41.977 394.17,41.027 394.17,38.177L394.17,24.407L400.77,24.407L400.77,16.507L394.17,16.507L394.17,6.707L394.21,6.707L394.2,6.727ZM370.65,37.757C369.58,40.687 367.3,42.757 363.18,42.757C358.76,42.757 355.1,39.627 354.91,35.277L378.41,35.277C378.41,35.117 378.51,33.777 378.51,32.527C378.51,21.967 372.45,15.527 362.31,15.527C353.89,15.527 346.15,22.347 346.15,32.787C346.15,43.887 354.08,50.337 363.11,50.337C371.19,50.337 376.38,45.607 378.05,39.937L370.65,37.757ZM355.1,29.217C355.3,26.217 357.84,22.737 362.45,22.737C367.52,22.737 369.65,25.937 369.81,29.217L355.1,29.217Z"
            style={{
              fill: 'rgb(94,94,97)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ExpertMarketLogo;
